import { IPage, ISearchPage } from '@/types/AppTypes'
import { httpRequest } from '@/utils/HttpRequest'

//详情
export interface IFatigueDrivingDetail {
    id?: string
    prefix?: string
    shopId?: string
    shopCode?: string
    shopName?: string
    branch?: string
    ver?: string
    enable?: string
    orgCode?: string
    orgName?: string
    contact?: string
    phone?: string
    address?: string
    status?: number | boolean
    sourceApp?: string
    categoryName?: string
    typeCode?: string
    typeName?: string
    suffixNum?: number
    settingType?: string
    isYear?: number
    isMonth?: number
    isDate?: number
    style?: string
    note?: string
    orderNum?: number
    traceId?: string
    deleteFlag?: number
    createTime?: string
    updateTime?: string
    createUser?: string
    updateUser?: string
    [key: string]: any
}
//新增
export interface IFatigueDrivingInsert {
    prefix?: string // "ad reprehenderit magna in",
    suffixNum?: number // 22,
    settingType?: string // "CALCULATE",
    isYear?: number // 55,
    isMonth?: number // 59,
    isDate?: number // 20180911,
    note?: string // "veniam sint laborum tempor",
    style?: string // "incididunt"
}

//编辑
export interface IFatigueDrivingUpdate extends IFatigueDrivingInsert {
    id?: string
}
//搜索条件
export interface IFatigueDrivingSearchFields {
    startTime?: string
    endTime?: string
    [key: string]: any
}

export interface IFatigueDrivingSearch extends IFatigueDrivingSearchFields, ISearchPage {
    shopId?: string
    shopCode?: string
}

export interface IpositionSearch extends IFatigueDrivingSearchFields, ISearchPage {}

class FatigueDrivingService {
    async page(searchVo: IFatigueDrivingSearch, config: object = {}) {
        const apiUrl = '/threeInspection/scheduling/fatigue/list'
        return await httpRequest.post<IPage<any>>(apiUrl, searchVo, config)
    }
    async insert(searchVo: IFatigueDrivingSearchFields) {
        const apiUrl = '/threeInspection/fatigueDriving/insert'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async edit(searchVo: IFatigueDrivingSearchFields) {
        const apiUrl = '/threeInspection/fatigueDriving/update'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async onDelete(searchVo: IFatigueDrivingSearchFields) {
        const apiUrl = '/threeInspection/fatigueDriving/delete'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async sendNotifications(searchVo: IFatigueDrivingSearchFields) {
        const apiUrl = '/threeInspection/fatigueDriving/notice'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async one(searchVo: IFatigueDrivingSearchFields) {
        const apiUrl = '/threeInspection/ciOrder/page'
        return await httpRequest.post<IPage<IFatigueDrivingDetail>>(apiUrl, searchVo)
    }
    async orderLogs(searchVo: IFatigueDrivingSearchFields) {
        const apiUrl = '/threeInspection/ciOrder/progress_log/list'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async getFatigueDrivingImg(updateVo: IFatigueDrivingUpdate) {
        const apiUrl = '/threeInspection/ciOrder/list_for_group'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    async getImageClassifyList(updateVo: IFatigueDrivingUpdate) {
        const apiUrl = '/threeInspection/ciOrder/list_for_group'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    async getTotal(shopCode: any) {
        const apiUrl = `/threeInspection/ciOrder/accountStatic/${shopCode}`
        return await httpRequest.get<any>(apiUrl)
    }
    async openDriver(id: any) {
        const apiUrl = `/threeInspection/scheduling/fatigue/open/${id}`
        return await httpRequest.get<any>(apiUrl)
    }
    async openEscortDriver(id: any) {
        const apiUrl = `/threeInspection/scheduling/fatigue/escortOpen/${id}`
        return await httpRequest.get<any>(apiUrl)
    }
    //导出
    async export(searchVo: any) {
        const appPageUrl = '/threeInspection/ciOrder/pageDetails/export'
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 })
    }

    //导出疲劳检测列表数据
    async exportList(searchVo: any) {
        const appPageUrl = '/threeInspection/fatigueDetection/export'
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 })
    }
}

export const fatigueDrivingService = new FatigueDrivingService()
